import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import "./About.css"; // Import external CSS

function AboutUs() {
  return (
    <div className="about-us-container">
      <Box
        // sx={{
        //   maxWidth: "1200px",
        //   margin: "0 auto",
        //   padding: { xs: "10px", sm: "20px", md: "30px" },
        // }}
      >
        {/* Header Section */}
        <Paper className="about-card" elevation={0}>
          <div className="about-header">
            <Typography 
              variant="h1" 
              component="h1"
              sx={{
                fontSize: { xs: '1.7rem', sm: '2rem', md: '2.5rem' },
                fontWeight: 700,
                textAlign: 'center'
              }}
            >
              About Our Company
            </Typography>
            <Typography 
              variant="body1" 
              sx={{ 
                textAlign: 'center',
                mt: 2,
                opacity: 0.9,
                fontSize: { xs: '0.95rem', sm: '1.05rem' }
              }}
            >
              Envision Integrated Services Private Limited - Excellence in Mechanical & IT Engineering
            </Typography>
          </div>

          {/* Company Information Table */}
          <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            <table className="company-info-table">
              <tbody>
                <tr>
                  <td>Registered Company Name</td>
                  <td>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      ENVISION INTEGRATED SERVICES PVT. LTD.
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>Brand Name</td>
                  <td>
                    <Typography variant="body1">
                      ENVISION INTEGRATED SERVICES PVT. LTD.
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>Company Official Email</td>
                  <td>
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                      -
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>Company Official Contact</td>
                  <td>
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                      -
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>Website</td>
                  <td>
                    <a
                      href="http://www.envisionis-group.com/"
                      className="website-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      http://www.envisionis-group.com/
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Domain Name</td>
                  <td>
                    <Typography variant="body1">envision</Typography>
                  </td>
                </tr>
                <tr>
                  <td>Industry Type</td>
                  <td>
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                      -
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td>
                    <Typography variant="body1">
                      <span className="address-line">913, 9th floor, Manjeera Trinity Corporate,</span>
                      <span className="address-line">Eeseva Lane, KPHB Colony, Kukatpally</span>
                      <span className="address-line">Hyderabad, Telangana, India - 500072</span>
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
        </Paper>

        {/* About Us Content Section */}
        <Paper className="about-card" elevation={0}>
          <Box sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
            <Typography variant="h2" className="about-title">
              About Us
            </Typography>
            
            <div className="section-divider"></div>
            
            <Typography variant="body1" className="about-paragraph">
              <strong>Envision Integrated Services Private Limited (Envision Group)</strong> offers 
              Mechanical and IT Engineering Services to global customers by adding value to their 
              business portfolio. We leverage our domain expertise and transformational process 
              knowledge to offer end-to-end solutions to our customers across Automotive, Aerospace, 
              Off-Highway, Industrial, Consumer, and Medical domains. Our innovative and cost-effective 
              services in mechanical engineering include Manufacturing Engineering Services, Digital 
              Factory Simulation, and Industrial Automation Services with offshore, onsite, and hybrid 
              work models, whereas in IT engineering we focus on the onsite staff augmentation model 
              and offer a wide range of Consultancy Services.
            </Typography>
            
            <Typography variant="body1" className="about-paragraph">
              Established in the year 2012, Envision is a market leader in the engineering industry 
              having a technological upper hand with evolved management approaches, unleashing the 
              full potential of all collaborators for solution-oriented and time-bound results. 
              Superlative business performances and competitive advantages help Envision to 
              capitalize opportunities with desired outcomes, support customers to outperform their 
              competition, and become a desired engineering partner.
            </Typography>
            
            <Typography variant="body1" className="about-paragraph">
              Envision strongly upholds ethical values like work-life balance, honesty, integrity, 
              trust & mutual respect and fosters healthy relationships with clients, employees, and 
              all other stakeholders. Repeat businesses from our customers act as testimonies for us 
              for our values, commitments, and collaborations.
            </Typography>
          </Box>
        </Paper>
        
        {/* Optional: Add a footer or additional sections here */}
        <Box sx={{ 
          mt: 4, 
          textAlign: 'center',
          color: 'text.secondary',
          fontSize: '0.9rem'
        }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} Envision Integrated Services Pvt. Ltd. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </div>
  );
}

export default AboutUs;